import type { CreateNewsfeedEventInput } from "~graphql/generated/graphql"
import { useCreateNewsfeedPostOpenedEventMutation } from "~graphql/generated/graphql"

export default function useCreatePostOpenedEvent() {
    const [createPostOpenedEventMutation, { loading: isLoading, error }] =
        useCreateNewsfeedPostOpenedEventMutation()

    const createPostOpenedEvent = (data: CreateNewsfeedEventInput) =>
        createPostOpenedEventMutation({ variables: { data } })

    return { createPostOpenedEvent, isLoading, error }
}
